/** @jsxImportSource @emotion/react */
import { useContext} from 'react';
import { Divider, Grid, Typography,Chip } from '@mui/material';
import { Il8nContext } from '../../Helper/i18n/index';

function DepositoryScheme(props) {
    const { dpScheme, handleDPPlanSelection, selectedPlan, selectedDPCharge, isSmallScreen, paymentDone,toggleDepositoryDetailsPopup,isSelected} = props
    const isCurrentDPChargePlanSelected = selectedDPCharge?.depositorySchemeId == dpScheme.depositorySchemeId
    const localeText = useContext(Il8nContext)

    const handleClick = (event) => {
        if (event.target.closest('.chip')) return;
        if (paymentDone) return;
        handleDPPlanSelection(dpScheme);
    };

    return (
        <Grid container item xs={6} md={2.5}
            css={{ border: "1px solid #D9DEE2", borderRadius: "10px", padding: isSmallScreen ? "10px" : "30px", textAlign: "center", cursor: "pointer", height: "180px",
                opacity: 1,
                background: isSelected ? "#BAF4FF" : "white",
                boxShadow: isSelected ? "0px 3px 6px #00000026" : "none", margin: "10px", position:"relative"
            }}
            onClick={handleClick}
        >
            <Grid item xs={12} css={{ padding: "10px" }}>
                <Chip xs={12}
                    className="chip"
                    label={localeText?.schemeDetailsTitle}
                    variant="outlined" color="primary" css={{
                        position: "absolute", top: "0.4rem", right: "0.4rem",
                        border: isSelected ? "1px solid #0098B0" : "1px solid #BAF4FF", cursor: "pointer"
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleDepositoryDetailsPopup(dpScheme);
                    }}
                />
            </Grid>
            <Grid item xs={12} css={{ borderBottom: "3px solid #0098B0" }}>
                <Typography variant={"h6"} display={"inline"} >
                    {dpScheme.depositorySchemeName}
                </Typography>
            </Grid>
            <Grid item xs={12} css={{ padding: "10px" }}>
                <Typography variant={"h6"} display={"inline"} color="#30940C">
                    {`₹${dpScheme.schemeAmount}`}
                </Typography>
            </Grid>
        </Grid>
    );
}

export default DepositoryScheme;